import * as React from "react";

function ChevronDownSharp(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12 8" fill="none" {...props}>
      <path
        d="M6 4.977L10.125.852l1.178 1.178L6 7.333.697 2.03 1.875.852 6 4.977z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoChevronDownSharp = React.memo(ChevronDownSharp);
export default MemoChevronDownSharp;
